import React from 'react';
import MyQnaHeader from './MyQnaHeader';
import MyQnaList from './MyQnaList';

const MyQna = ({ qnaList, hasMore, onLoadMore, totalCount }) => {
  return (
    <div className='flex flex-col max-w-[868px] w-full items-start'>
      <MyQnaHeader />
      <MyQnaList
        qnaList={qnaList}
        hasMore={hasMore}
        onLoadMore={onLoadMore}
        totalCount={totalCount}
      />
    </div>
  );
};

export default MyQna;
